import { Injectable } from '@angular/core';
import { Trip, TripValidation } from 'models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TripService {
    constructor(private http: HttpClient) {}

    get(): Observable<Trip[]> {
        return this.http.get<Trip[]>('api/trips/get');
    }

    create(trip: Trip): Observable<Trip> {
        return this.http.post<Trip>('api/trips/create', trip);
    }

    priceCheck(trip: Trip): Observable<TripValidation> {
        return this.http.post<TripValidation>('api/trips/price-check', trip);
    }
}
